import { INDRAApiService } from '@ibe.services/api.indra.service';
import { HttpClient } from '@angular/common/http';
import { MOCK_STATUS, MOCK_URL_ORIGINS, URL_BFM_LOCATION_ORIGIN, URL_BFM_LOCATION_DESTINATION, MOCK_URL_DESTINATIONS, MOCK_URL_DESTINATIONS_PAY_WITH_MILES_ONLY, URL_BFM_LOCATION_ORIGIN_MULTICITY, URL_BFM_GEOGRAPHY_CONTINENTS, MOCK_URL_CONTINENTS, URL_BFM_GEOGRAPHY_AIRPORTS, MOCK_URL_AIRPORTS } from '@ibe.config';
import * as i0 from "@angular/core";
import * as i1 from "./api.indra.service";
import * as i2 from "@angular/common/http";
var INDRAAirportLocationService = /** @class */ (function () {
    function INDRAAirportLocationService(api, http) {
        this.api = api;
        this.http = http;
    }
    INDRAAirportLocationService.prototype.IndraGetOrigins = function (params) {
        if (MOCK_STATUS.ORIGINS) {
            return this.http.get(MOCK_URL_ORIGINS);
        }
        else {
            this.origins = this.api.INDRA_post(URL_BFM_LOCATION_ORIGIN, params);
            return this.origins;
        }
    };
    INDRAAirportLocationService.prototype.IndraGetDestinations = function (params) {
        if (MOCK_STATUS.DESTINATIONS) {
            var MOCK_URL_PATH = MOCK_URL_DESTINATIONS;
            if (params.payWithMiles) {
                MOCK_URL_PATH = MOCK_URL_DESTINATIONS_PAY_WITH_MILES_ONLY;
            }
            return this.http.get(MOCK_URL_PATH);
        }
        else {
            this.destinations = this.api.INDRA_post(URL_BFM_LOCATION_DESTINATION, params);
            return this.destinations;
        }
    };
    INDRAAirportLocationService.prototype.INDRAGetMulticityOrigins = function (params) {
        if (MOCK_STATUS.MULTICITY_ORIGINS) {
            return this.http.get(MOCK_URL_ORIGINS);
        }
        else {
            this.origins = this.api.INDRA_post(URL_BFM_LOCATION_ORIGIN_MULTICITY, params);
            return this.origins;
        }
    };
    INDRAAirportLocationService.prototype.INDRAGetContinents = function (params) {
        if (MOCK_STATUS.CONTINENTS) {
            return this.http.get(MOCK_URL_CONTINENTS);
        }
        else {
            this.continents = this.api.INDRA_post(URL_BFM_GEOGRAPHY_CONTINENTS, params);
            return this.continents;
        }
    };
    INDRAAirportLocationService.prototype.INDRAGetAirports = function (params) {
        if (MOCK_STATUS.AIRPORTS) {
            return this.http.get(MOCK_URL_AIRPORTS);
        }
        else {
            this.airports = this.api.INDRA_post(URL_BFM_GEOGRAPHY_AIRPORTS, params);
            return this.airports;
        }
    };
    INDRAAirportLocationService.ngInjectableDef = i0.defineInjectable({ factory: function INDRAAirportLocationService_Factory() { return new INDRAAirportLocationService(i0.inject(i1.INDRAApiService), i0.inject(i2.HttpClient)); }, token: INDRAAirportLocationService, providedIn: "root" });
    return INDRAAirportLocationService;
}());
export { INDRAAirportLocationService };
